import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
// Contenido de cada documento legal — edita aquí el texto de Privacidad y Términos
const legalContent = {
  privacy: {
    title: 'Política de Privacidad',
    body: ['En RenuevaTE_90 y "Saludable sin ser Esclavo" valoramos y respetamos tu privacidad. Esta política describe cómo recopilamos, usamos y protegemos tu información personal.', 'Información que recopilamos: Cuando completas nuestro diagnóstico o te inscribes en el programa, podemos recopilar datos como tu nombre, correo electrónico, información de contacto y respuestas relacionadas con tus hábitos y objetivos de bienestar.', 'Uso de la información: Utilizamos tus datos exclusivamente para brindarte orientación personalizada, gestionar tu participación en el programa y comunicarnos contigo sobre tu proceso. Nunca vendemos ni compartimos tu información con terceros con fines comerciales.', 'Seguridad: Implementamos medidas técnicas y organizativas razonables para proteger tu información contra accesos no autorizados, pérdida o alteración.', 'Tus derechos: Puedes solicitar en cualquier momento el acceso, la corrección o la eliminación de tus datos personales escribiéndonos a través de nuestros canales oficiales.', 'Al utilizar este sitio y completar el diagnóstico, aceptas las prácticas descritas en esta Política de Privacidad.']
  },
  terms: {
    title: 'Términos de Servicio',
    body: ['Bienvenida a RenuevaTE_90. Al acceder a este sitio web y participar en nuestro programa, aceptas los siguientes términos y condiciones.', 'Naturaleza del programa: RenuevaTE_90 es un programa educativo de bienestar integral. No constituye asesoría médica, diagnóstico ni tratamiento. Siempre debes consultar con tu profesional de salud antes de iniciar cualquier cambio en tu alimentación, actividad física o estilo de vida.', 'Compromiso de la participante: El programa requiere dedicación y compromiso personal durante 90 días. Los resultados varían de persona a persona y dependen de la constancia y las circunstancias individuales de cada participante.', 'Propiedad intelectual: Todo el contenido, materiales, guías y recursos del programa son propiedad de "Saludable sin ser Esclavo" y están protegidos por derechos de autor. No está permitido reproducir, distribuir ni compartir el material sin autorización.', 'Pagos y acceso: El acceso al programa está sujeto al pago correspondiente. Las condiciones de garantía y reembolso se detallan en el momento de la inscripción.', 'Al inscribirte, confirmas que has leído y aceptado estos Términos de Servicio.']
  }
};
type LegalKey = keyof typeof legalContent;
export function Footer() {
  const [activeModal, setActiveModal] = useState<LegalKey | null>(null);
  return <footer className="border-t border-gold/20 pt-16 pb-8 bg-[#0D1B3E]" data-id="element-96">
      <div className="max-w-6xl mx-auto px-6" data-id="element-97">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-12" data-id="element-98">
          <div className="flex items-center gap-3" data-id="element-99">
            <img src="https://cdn.magicpatterns.com/uploads/81dbfNW6C6WxGsU82gWpWz/ChatGPT_Image_26_may_2026,_17_06_14.png" alt="RenuevaTE_90 Logo" className="h-16 w-auto object-contain opacity-80 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-100" />
            <div className="flex flex-col" data-id="element-101">
              <span className="font-serif font-semibold text-cream text-xl tracking-wide" data-id="element-102">
                RenuevaTE<span className="text-gold" data-id="element-103">_90</span>
              </span>
              <span className="text-cream/50 text-xs tracking-widest uppercase" data-id="element-104">
                Saludable sin ser Esclavo
              </span>
            </div>
          </div>

          {/* Enlaces legales — abren un pop-up con su propio contenido */}
          <div className="flex gap-6 text-sm text-cream/60" data-id="element-105">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-gold transition-colors" data-id="element-106">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="hover:text-gold transition-colors" data-id="element-107">
              Términos de Servicio
            </button>
          </div>
        </div>

        <div className="border-t border-cream/10 pt-8 text-center text-xs text-cream/40 leading-relaxed max-w-4xl mx-auto" data-id="element-108">
          <p className="mb-4" data-id="element-109">
            <strong data-id="element-110">Aviso Médico:</strong> La información proporcionada en este
            sitio web y en el programa RenuevaTE_90 tiene fines educativos e
            informativos únicamente y no pretende sustituir el consejo,
            diagnóstico o tratamiento médico profesional. Siempre busque el
            consejo de su médico u otro proveedor de salud calificado con
            cualquier pregunta que pueda tener con respecto a una condición
            médica.
          </p>
          <p data-id="element-111">
            &copy; {new Date().getFullYear()} Saludable sin ser Esclavo. Todos
            los derechos reservados.
          </p>
        </div>
      </div>

      {/* Pop-up modal de documentos legales */}
      <AnimatePresence data-id="element-112">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={() => setActiveModal(null)} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-navy/70 backdrop-blur-sm" role="dialog" aria-modal="true" aria-labelledby="legal-modal-title" data-id="element-113">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} onClick={e => e.stopPropagation()} className="relative w-full max-w-2xl max-h-[85vh] overflow-hidden rounded-2xl bg-cream shadow-2xl border border-gold/30 flex flex-col" data-id="element-114">
              <div className="flex items-center justify-between px-6 md:px-8 py-5 border-b border-navy/10 bg-cream" data-id="element-115">
                <h3 id="legal-modal-title" className="font-serif text-2xl text-navy" data-id="element-116">
                  {legalContent[activeModal].title}
                </h3>
                <button onClick={() => setActiveModal(null)} aria-label="Cerrar" className="text-navy/50 hover:text-navy hover:bg-navy/5 rounded-full p-2 transition-colors" data-id="element-117">
                  <X className="w-5 h-5" data-id="element-118" />
                </button>
              </div>

              <div className="overflow-y-auto px-6 md:px-8 py-6 space-y-4" data-id="element-119">
                {legalContent[activeModal].body.map((paragraph, idx) => <p key={idx} className="text-navy/75 text-sm md:text-base leading-relaxed" data-id="element-120">
                    {paragraph}
                  </p>)}
              </div>

              <div className="px-6 md:px-8 py-4 border-t border-navy/10" data-id="element-121">
                <button onClick={() => setActiveModal(null)} className="w-full bg-gold hover:bg-gold/90 text-navy font-semibold py-3 rounded-full transition-colors" data-id="element-122">
                  Entendido
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </footer>;
}